import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progressBar',
  templateUrl: './progressBar.component.html',
  styleUrls: ['./progressBar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
